export const flexch = `display:flex; justify-content:center; align-items:center;`;
export const flexcv = `display:flex; flex-direction:column; justify-content:center; align-items:center;`;

export const backgroundGeneral = `background-size: cover; background-position: center;`;
